import moment from 'moment'

export default {
  methods: {
    formatDate(unixTimestamp) {
      return moment.unix(unixTimestamp).format('MMM D, YYYY')
    }
  }
}
